export const FULL_RAY_BACKGROUND = "portal/m/3p/tg_ray_background.png";

export const HALF_RAY_BACKGROUND = "portal/m/Rays.png";

export const DELIVERY_EXECUTIVE = "portal/m/DE.png";

export const backgroundImageFormate = (url: string) => `url(${url})`;

export const PLACEHOLDERS = {
    PLAN_INFO_TEXT: "{{plan_info_text}}",
};
